<template>
    <b-modal
        id="csv-errors-modal"
        title="CSV Errors"
        ref="CSVErrorsVoucher"
        @hidden="closeModal">
        <ul>
            <li v-for="(csvError, index) in csvErrors" v-bind:key="index">
                {{ csvError }}
            </li>
        </ul>
        <div slot="modal-footer" class="pt-4">
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="closeModal">
                OK
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

function initialState() {
    return {
        
    }
}

export default {
    name: "CSVErrors",
    props: ["status", "name"],
    data() {
        return initialState();
    },
    computed: {
        ...mapState("estoreVouchers", ["loading", "errors", "csvErrors", "modal"]),
    },
    methods: {
        closeModal: function() {
            this.$store.commit("estoreVouchers/setModal", {
                type: "csvErrors",
                status: false,
                uuid: null,
                name: ""
            });
        }
    },
    watch: {
        status: function(status) {
            if (status == true) {
                this.$refs.CSVErrorsVoucher.show();
            } else {
                this.$refs.CSVErrorsVoucher.hide();
            }
        }
    }
};
</script>
